
export const ERROR_MESSAGES = {
  genericError: "Something went wrong. Please try again later.",
  networkError: "Network error. Please check your internet connection.",
  unauthorized: "You are not authorized to perform this action.",
  forbidden: "You don’t have permission to access this resource.",
  notFound: "The requested resource was not found.",
  serverError: "No response from server. Please check your internet connection or try again later.",
  validationError: "Some fields have invalid values. Please correct them and try again.",
  timeoutError: "Request timed out. Please try again.",
  duplicateEntry: "This entry already exists.",
  sessionExpired: "Your session has expired. Please log in again.",
  invalidCredentials: "Invalid username or password.",
  tooManyRequests: "Too many requests. Please try again later.",
  unsupportedFileType: "Unsupported file type. Please upload a valid file.",
  fileTooLarge: "File is too large. Please upload a smaller file.",
  badRequest: "Bad Request",
  noResponse: "No response from server. Please try again later.",
  emailNotVerified: "Email is not verified.",
  selectPaymentMethod : "Please select a payment method to proceed with your order.",
  enterValidCard : "Please enter valid card details to add this payment method.",
  deletePaymentMethodError: "Failed to delete payment method. Please try again.",
  multipleLogin : "You have logged into another device.",
  requestError : "Request setup error! Please try again.",
  internalConnectionFailed: "Please check your internet connection and try again.",
  imageSize : `The selected image exceeds the 5MB limit.<br> Please choose a smaller file for upload.`,
  promoCodeNotApplied: "This gift voucher or promo code cannot be applied as the order total is too low.",
  promoCodeExpired:"This gift voucher or promo code has expired.",
  cannotModify: "Cannot modify page settings after print request has been submitted",
  noDataFound:"No data found , please try again"
};

export const SUCCESS_MESSAGES = {
  emailVerified: "Email verified successfully.",
  paymentProcessed: "Payment processed successfully.",
  addedToCart: "Item added to cart successfully.",
  removedFromCart: "Item removed from cart successfully.",
  saveFormData : "Your changes have been saved.",
  promoCodeApplied:"Gift Voucher or Promo Code applied successfully.",
  paymentMethodDeleted: "Payment method deleted successfully."
};

export const SIZE = {
  maxImageSize : 5 * 1024 * 1024
}


